import { ReactNode } from "react"
import { Button, Modal } from "react-bootstrap"

type Props = {
    isOpen: boolean,
    title: string,
    children: {
        body: ReactNode
        footer: ReactNode
    }
    open: any
    close: any
    submit?: any
}

export function ModalUploadFile({ title, children, close, isOpen, submit }: Props) {
    return (
        <>
            <Modal show={isOpen} onHide={() => close()} size={"xl"} fullscreen={"md-down"}>
                <Modal.Header closeButton>
                    <Modal.Title className="ms-3 lead" style={{ fontSize: "30px" }}>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {children.body}
                </Modal.Body>
                <Modal.Footer>
                    {/* <Button variant="outline-primary" onClick={() => { close(); submit() }} size="sm">
                        Enviar Arquivo
                    </Button> */}
                    {children.footer}
                </Modal.Footer>
            </Modal>
        </>
    )

}
